export default {
    APPEARANCE: 0,
    PROPERTIES: 1,
    MOVEMENT: 2,
    ROTATION: 3,
    GROWTH_SHRINKAGE: 4,
    STAYS_DIFFERENT: 5
};
